// src/utils/constants.js

export const CLIMBING_STYLES = {
  SPORT: 'sport',
  TRAD: 'trad',
  BOULDER: 'boulder'
};